export default __webpack_public_path__ + "static/media/640x300_02.607342a6.jpg";